module.exports = __webpack_public_path__ + "img/house_22.8be46547.jpg";